export default __webpack_public_path__ + "locales/nl/PeopleTranslations.json?hash=0dfa7047404c87533b082f92b532e3e6";